module.exports = __webpack_public_path__ + "static/media/ignite.0cf7957f.png";